import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'dg_cookie_consent';
const CONVERSION_SEND_TO = 'AW-18114321690/189kCIvixKAdEJq6yr1D';

const readChoice = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

const saveChoice = (value) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // Storage blocked: the choice applies to this visit only.
  }
};

const applyConsent = (granted) => {
  if (typeof window.gtag !== 'function') return;
  const value = granted ? 'granted' : 'denied';
  window.gtag('consent', 'update', {
    ad_storage: value,
    ad_user_data: value,
    ad_personalization: value,
    analytics_storage: value,
  });
};

const isContactLink = (href) =>
  href.startsWith('mailto:') ||
  href.includes('go.digitalgigs.eu/chat') ||
  href.includes('wa.me/') ||
  href.includes('api.whatsapp.com');

const CookieConsent = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const choice = readChoice();
    if (choice === 'granted') {
      applyConsent(true);
    } else if (!choice) {
      setOpen(true);
    }

    const reopen = () => setOpen(true);

    // Google Ads conversion: any WhatsApp/chat or email link click.
    const onClick = (event) => {
      const link = event.target.closest ? event.target.closest('a[href]') : null;
      if (!link) return;
      const href = link.getAttribute('href') || '';
      if (isContactLink(href) && typeof window.gtag === 'function') {
        window.gtag('event', 'conversion', {
          send_to: CONVERSION_SEND_TO,
          value: 1.0,
          currency: 'EUR',
        });
      }
    };

    window.addEventListener('dg:open-cookie-settings', reopen);
    document.addEventListener('click', onClick, true);
    return () => {
      window.removeEventListener('dg:open-cookie-settings', reopen);
      document.removeEventListener('click', onClick, true);
    };
  }, []);

  const choose = (granted) => {
    saveChoice(granted ? 'granted' : 'denied');
    applyConsent(granted);
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[200] p-4 sm:p-6">
      <div className="max-w-3xl mx-auto bg-white border border-slate-200 shadow-2xl rounded-3xl p-6 sm:p-8">
        <h2 className="text-lg font-extrabold text-slate-900 mb-2">Cookies &amp; tracking</h2>
        <p className="text-slate-600 font-medium leading-relaxed mb-6">
          We use marketing cookies to measure which of our ads lead to enquiries. They are only set if you accept.
          You can change your choice at any time via &quot;Cookie settings&quot; in the footer. More in our{' '}
          <Link to="/privacy" className="text-emerald-600 font-bold hover:text-emerald-700 underline">Privacy Policy</Link>.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 sm:justify-end">
          <button
            type="button"
            onClick={() => choose(false)}
            className="px-6 py-3 rounded-full border-2 border-slate-200 text-slate-700 font-bold hover:border-slate-300 transition-colors"
          >
            Reject
          </button>
          <button
            type="button"
            onClick={() => choose(true)}
            className="px-6 py-3 rounded-full bg-emerald-600 text-white font-bold hover:bg-emerald-700 transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
